import React, { useEffect, useState } from "react";
import "./Home.css";

const HERO_BG_URL =
  "https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/home.png";

const TRIPLE_URL =
  "https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/images.png";

const WHATSAPP_URL = "https://wa.me/972542317742";
const INSTAGRAM_URL = "https://www.instagram.com/mariage_family/";
const EMAIL_ADDRESS = "mariagefamily.il@gmail.com";
const PHONE_DISPLAY = "054-2317742";

const HERO_FEATURES = [
  "אישורי הגעה חכמים לחתונה, ברמה הגבוהה ביותר",
  "דגש על איכות ויוקרה בכל פרט",
  "מגוון שפות – עברית, אנגלית וצרפתית",
  "סידור הושבה נוח ומסודר",
  "הזמנות ואישורי הגעה בוואטסאפ",
  "שירות ליווי אישי לאורך כל הדרך",
];

const COUPLES = [
  {
    name: "דן ולאה",
    image:
      "https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/DSC_2057.JPG",
    text: "אין ספק שהשימוש במריאז' הקל עלינו מאוד. האתר פשוט ונוח לשימוש, וכל נושא אישורי ההגעה הפך למסודר וקל לניהול. השירות שקיבלנו היה מעל ומעבר – תמיד הייתה זמינות, סבלנות ורצון אמיתי לעזור. הרגשנו שמלווים אותנו לאורך כל הדרך ושבאמת אכפת מההצלחה של האירוע שלנו. תודה רבה על הכל, ממליצים מכל הלב!",
  },
  {
    name: "ארז ועבריה",
    image:
      "https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/88062.jpg",
    text: "וואו, אני לא יודעת מאיפה להתחיל להמליץ! האתר של Mariage פשוט מושלם והפך את כל החלק המלחיץ של אישורי ההגעה לחוויה פשוטה וכיפית. האתר עצמו סופר נוח, ידידותי למשתמש (גם לנו וגם לאורחים) ומעוצב מהמם. מעבר לאתר המעולה, לאה פשוט מדהימה, נחמדה, זמינה לכל שאלה ובכל שעה. בתקופה כל כך לחוצה, היא הרגיעה אותי בדיוק כשהייתי צריכה, ועשתה סדר בכל אחוזי המאשרים בצורה הכי מקצועית שיש. הכל עבר חלק, בלי שום תקלה. ממליצה עליה ועל האתר בלב שלם לכל מי שמארגן אירוע!",
  },
  {
    name: "הדר ועידו",
    image:
      "https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/88076.jpg",
    text: "השתמשנו במריאז' לאישורי ההגעה בחתונה שלנו, וזו הייתה אחת ההחלטות הכי טובות שקיבלנו. האתר היה פשוט ונוח לשימוש, הכל עבד בצורה חלקה, והשירות שקיבלנו היה מדהים. כל שאלה נענתה במהירות ובסבלנות, וזה הוריד מאיתנו המון לחץ בתקופה שגם ככה עמוסה. ממליצים מכל הלב!",
  },
  {
    name: "אביגד ונעמי",
    image:
      "https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/88065.jpg",
    text: "שירות מצוין, אתר נוח מאוד וממש חסך לנו המון זמן וכאבי ראש בתקופת ההכנות לחתונה. הכל היה מסודר, ברור וקל לתפעול, גם עבורנו וגם עבור האורחים. כל התהליך עבר בצורה חלקה, ובכל פעם שהייתה לנו שאלה קיבלנו מענה מהיר, מקצועי ואדיב. הרגשנו שיש על מי לסמוך לאורך כל הדרך, וזה נתן לנו הרבה שקט בתקופה כל כך עמוסה. תודה רבה על השירות הנהדר, בהחלט נמליץ לאחרים!",
  },
];

const SERVICES = [
  {
    front: "מעקב קל ונח אחרי כמות מוזמנים",
    back: "לוח בקרה חכם שמראה בזמן אמת מי אישר הגעה, מי עדיין באוויר ומי טרם ענה - כדי שתדעו בדיוק כמה מנות להזמין ותישנו בשקט לפני האירוע.",
  },
  {
    front: "שליחת הזמנות אוטומטית",
    back: "ההזמנה הדיגיטלית שלכם יוצאת לכל הרשימה בלחיצה אחת, מעוצבת ואישית, בלי להתעסק אחד-אחד עם כל מוזמן.",
  },
  {
    front: "אישורי הגעה דרך ווצאפ",
    back: "המוזמנים עונים בפשטות בתוך שיחת הוואטסאפ הרגילה שלהם - בלי הורדת אפליקציה ובלי הרשמה. אצלכם הכל מתעדכן אוטומטית.",
  },
  {
    front: "סידור שולחנות ומקומות ישיבה",
    back: "כלי גרירה ושחרור פשוט לבניית סידור הושבה מותאם אישית, כולל שיוך מוזמנים לשולחנות בהתאם לרשימה ולבקשות שלכם.",
  },
  {
    front: "ליווי לאורך כל הדרך",
    back: "צוות אנושי זמין לכם מרגע הרכישה ועד אחרי האירוע - לכל שאלה, עדכון או שינוי ברגע האחרון.",
  },
  {
    front: "מגוון שפות",
    back: "תקשורת עם המוזמנים בעברית, אנגלית וצרפתית - כדי שגם משפחה וחברים מחו\"ל ירגישו חלק מהחגיגה.",
  },
];

const FAQ_ITEMS = [
  {
    q: "איך זה עובד בפועל?",
    a: "לאחר הרכישה מעלים את רשימת המוזמנים לאזור האישי באתר, אנחנו שולחים בשמכם הזמנות ואישורי הגעה דרך וואטסאפ, ואתם עוקבים אחרי התשובות בזמן אמת מכל מקום.",
  },
  {
    q: "האם אישורי ההגעה זמינים גם באנגלית ובצרפתית?",
    a: "כן. ניתן לשלוח ולקבל אישורי הגעה בעברית, באנגלית ובצרפתית, כך שגם מוזמנים דוברי שפות אחרות מרגישים בבית. שימו לב: למספרים בינלאומיים (מחוץ לישראל) התקשורת מתבצעת דרך וואטסאפ בלבד, ללא שיחות טלפון.",
  },
  {
    q: "האם המוזמנים צריכים להתקין אפליקציה?",
    a: "לא. המוזמנים מקבלים ועונים ישירות מתוך הוואטסאפ הרגיל שלהם, בלי להתקין או להירשם לשום דבר.",
  },
  {
    q: "מה ההבדל בין המסלולים Premium, Medium ו-Basic?",
    a: 'ההבדל העיקרי הוא בכמות ההודעות והשירותים הנלווים: ב-Premium יש גם שיחות טלפון והודעת מיקום ביום האירוע, ב-Medium שלוש הודעות וואטסאפ לכל מוזמן, וב-Basic שליחה עצמאית עם מעקב אחר אישורי הגעה. בכל המסלולים כלול מעקב אישורי הגעה וסידור הושבה - כל הפרטים בטבלת המסלולים למעלה.',
  },
  {
    q: "מה קורה אם יש לי יותר מוזמנים ממה שכלול בחבילה?",
    a: 'אין בעיה - ניתן להוסיף רשומות נוספות במחיר של 1 ש"ח בלבד לרשומה, מעבר למכסה שכלולה בחבילה שבחרתם.',
  },
  {
    q: "האם אתם מגיעים גם לאולם ביום החתונה?",
    a: 'כן, ניתן להוסיף הגעה שלנו לאולם וליווי אישי ביום האירוע עצמו, בעלות נוספת של 1,200 ש"ח בלבד.',
  },
  {
    q: "איך מתבצע התשלום?",
    a: "התשלום מתבצע באופן מאובטח בכרטיס אשראי, ישירות באתר דרך מערכת סליקה מוצפנת.",
  },
  {
    q: "האם ניתן לבטל את ההזמנה?",
    a: "כן, בהתאם למדיניות הביטולים בתקנון האתר. אם חלק מהשירות כבר סופק (למשל אישורי הגעה שכבר התקבלו), ייתכנו דמי ביטול בהתאם לחוק. לפרטים המלאים ניתן לעיין בתקנון השימוש.",
  },
];

const PLANS = [
  {
    key: "premium",
    title: "Premium",
    lines: [
      "שלוש הודעות ווצאפ,",
      "הודעה עם מיקום ביום עצמו",
      "ושתי שיחות טלפון",
      "עבור כל מוזמן.",
      "מעקב קל ונוח אחר אישורי הגעה.",
      "סידור שולחנות ומקומות ישיבה.",
      "(עד 600 רשומות)",
    ],
    price: 'רק 750 ש"ח',
    buyUrl: "https://mariage-il.com/buy?packege=premium",
    blobClass: "blob--premium",
  },
  {
    key: "medium",
    title: "Medium",
    lines: [
      "שלוש הודעות ווצאפ לכל מוזמן",
      "מעקב קל ונוח אחר אישורי הגעה",
      "(עד 600 רשומות)",
      "סידור שולחנות ומקומות ישיבה",
      " ",
      " ",
    ],
    price: 'רק 400 ש"ח',
    buyUrl: "https://mariage-il.com/buy?packege=medium",
    blobClass: "blob--medium",
  },
  {
    key: "basic",
    title: "Basic",
    lines: [
      "שליחת הודעות עצמאית ומעקב אחר אישורי הגעה",
      "(עד 200 רשומות)",
      "סידור שולחנות ומקומות ישיבה",
      " ",
      " ",
      " ",
    ],
    price: 'רק 150 ש"ח',
    buyUrl: "https://mariage-il.com/buy?packege=basic",
    blobClass: "blob--basic",
  },
];

const WhatsappIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.79.47 3.47 1.29 4.93L2 22l5.29-1.39a9.87 9.87 0 0 0 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Zm0 18.03h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.14.82.84-3.06-.2-.31a8.18 8.18 0 0 1-1.27-4.36c0-4.53 3.7-8.22 8.26-8.22 2.21 0 4.28.86 5.84 2.42a8.18 8.18 0 0 1 2.42 5.83c0 4.53-3.7 8.21-8.26 8.21Zm4.53-6.15c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.78.97-.14.16-.29.18-.54.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.23-1.46-1.37-1.71-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.4-.42-.56-.43h-.48c-.16 0-.43.06-.65.31-.23.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.55.12.16 1.74 2.66 4.22 3.73.59.25 1.05.4 1.41.51.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.19.21-.58.21-1.08.14-1.19-.06-.1-.22-.16-.47-.28Z"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.72 3.72 0 0 1-1.38-.9 3.72 3.72 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.8.31-1.48.72-2.15 1.4-.68.67-1.09 1.36-1.4 2.15-.3.76-.5 1.64-.56 2.91C.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.8.72 1.48 1.4 2.15.67.68 1.36 1.09 2.15 1.4.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.8-.31 1.48-.72 2.15-1.4.68-.67 1.09-1.36 1.4-2.15.3-.76.5-1.64.56-2.91.06-1.27.07-1.68.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.87 5.87 0 0 0-1.4-2.15A5.87 5.87 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0Zm0 5.84A6.16 6.16 0 1 0 12 18.16 6.16 6.16 0 0 0 12 5.84Zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm6.41-10.4a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0Z"
    />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
    <path
      fill="currentColor"
      d="M2 5.5A1.5 1.5 0 0 1 3.5 4h17A1.5 1.5 0 0 1 22 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 18.5v-13Zm2.2.5 7.3 5.47a.8.8 0 0 0 .96 0L19.8 6H4.2ZM20 7.68l-6.62 4.96a2.8 2.8 0 0 1-3.36 0L3.4 7.68V18.5c0 .05.04.09.1.09h17a.1.1 0 0 0 .1-.1V7.68Z"
    />
  </svg>
);

const Home = () => {
  // ===== Services flip cards =====
  const [flipped, setFlipped] = useState(() => SERVICES.map(() => false));
  const toggleCard = (index) => {
    setFlipped((prev) => prev.map((v, i) => (i === index ? !v : v)));
  };

  // ===== Couples carousel =====
  const [activeCouple, setActiveCouple] = useState(0);
  const totalCouples = COUPLES.length;

  const nextCouple = () => setActiveCouple((i) => (i + 1) % totalCouples);
  const prevCouple = () =>
    setActiveCouple((i) => (i - 1 + totalCouples) % totalCouples);

  useEffect(() => {
    if (totalCouples <= 1) return;
    const t = setInterval(() => {
      setActiveCouple((i) => (i + 1) % totalCouples);
    }, 6000);
    return () => clearInterval(t);
  }, [totalCouples]);

  const couple = COUPLES[activeCouple];

  // ===== FAQ accordion =====
  const [openFaq, setOpenFaq] = useState(0);
  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? -1 : index));
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <div className="home-container">
      {/* HERO */}
      <section
        className="home-hero"
        style={{ backgroundImage: `url(${HERO_BG_URL})` }}
        aria-label="Mariage – אישורי הגעה לחתונה"
      >
        <div className="home-hero__overlay" />
        <div className="home-hero__content">
          <h1 className="home-hero__title">
            אישורי הגעה לחתונה, בקלות וברמה הגבוהה ביותר
          </h1>
          <p className="home-hero__intro">
            Mariage מלווה אתכם בניהול אישורי הגעה לחתונה בוואטסאפ, מעקב
            מוזמנים וסידורי הושבה – בעברית, אנגלית וצרפתית, במקום אחד.
          </p>
          <ul className="home-hero__features">
            {HERO_FEATURES.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
          <a href="#packages" className="home-hero__cta">
            לצפייה במסלולים
          </a>
        </div>
      </section>

      {/* THREE IMAGES STRIP */}
      <section className="triple-strip" aria-label="רגעים מהחתונה">
        <div className="triple-strip__frame">
          <img
            src={TRIPLE_URL}
            alt="רגעים מהחתונה שלכם – טוסט יין, שלט קבלת פנים וסידור שולחנות עם Mariage"
            draggable="false"
            loading="lazy"
          />
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section
        className="services-section"
        aria-labelledby="services-heading"
      >
        <div className="services-inner">
          <h2 id="services-heading" className="section-title">
            השירות שלנו
          </h2>
          <p className="section-subtitle">
            ליווי מלא בניהול אישורי הגעה, מוזמנים והושבה לחתונה שלכם
          </p>

          <div className="services-grid">
            {SERVICES.map((item, idx) => (
              <button
                key={item.front}
                type="button"
                className={`flip-card ${flipped[idx] ? "is-flipped" : ""}`}
                onClick={() => toggleCard(idx)}
                aria-pressed={flipped[idx]}
              >
                <div className="flip-card__inner">
                  <div className="flip-card__face flip-card__front">
                    <h3>{item.front}</h3>
                  </div>

                  <div className="flip-card__face flip-card__back">
                    <p>{item.back}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* COUPLES SECTION */}
      <section className="couples-section" aria-labelledby="couples-heading">
        <div className="couples-inner">
          <h2 id="couples-heading" className="section-title">
            הזוגות שלנו
          </h2>

          <div className="couples-area">
            <button
              type="button"
              className="arrow-btn arrow-left"
              onClick={prevCouple}
              aria-label="המלצה קודמת"
            >
              ‹
            </button>

            <div className="couples-content">
              <div className="couple-photo">
                <img src={couple.image} alt={`${couple.name} – זוג לקוחות מרוצים של Mariage`} loading="lazy" />
              </div>

              <div className="couple-review-card">
                <h3 className="couple-name">{couple.name}</h3>
                <p className="couple-reco">{couple.text}</p>
              </div>
            </div>

            <button
              type="button"
              className="arrow-btn arrow-right"
              onClick={nextCouple}
              aria-label="המלצה הבאה"
            >
              ›
            </button>
          </div>
        </div>
      </section>

      {/* PLANS SECTION */}
      <section className="plans-section" id="packages" aria-labelledby="plans-heading">
        <div className="plans-inner">
          <h2 id="plans-heading" className="section-title">
            המסלולים שלנו
          </h2>

          <p className="plans-note">
            לכל חבילה ניתן להוסיף רשומות במחיר של שקל לרשומה. בנוסף, ניתן
            להוסיף הגעה שלנו לאולם וליווי ביום האירוע בעלות של 1,200 ש"ח בלבד.
          </p>

          <div className="plans-grid">
            {PLANS.map((p) => (
              <div key={p.key} className="plan-col">
                <div className={`plan-blob ${p.blobClass}`}>
                  <div className="plan-blob__inner" dir="rtl">
                    <div className="plan-title">{p.title}</div>

                    <ul className="plan-lines">
                      {p.lines.filter(Boolean).map((line, i) => (
                        <li key={i}>{line}</li>
                      ))}
                    </ul>

                    <div className="plan-price">{p.price}</div>

                    <a className="plan-buy" href={p.buyUrl}>
                      לרכישה
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta-section" aria-label="קריאה לפעולה">
        <div className="final-cta-box">
          <h2>מוכנים להתחיל לתכנן את אישורי ההגעה שלכם?</h2>
          <p>
            בחרו מסלול שמתאים לכם או דברו איתנו ישירות – נשמח ללוות אתכם עד
            ליום החתונה.
          </p>
          <div className="final-cta-actions">
            <a href="#packages" className="final-cta-btn final-cta-btn--primary">
              לרכישת מסלול
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="final-cta-btn final-cta-btn--secondary"
            >
              דברו איתנו בוואטסאפ
            </a>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="faq-section" aria-labelledby="faq-heading">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
        <div className="faq-inner">
          <h2 id="faq-heading" className="section-title">
            שאלות ותשובות
          </h2>

          <div className="faq-list">
            {FAQ_ITEMS.map((item, idx) => {
              const isOpen = openFaq === idx;
              return (
                <div
                  key={item.q}
                  className={`faq-item ${isOpen ? "is-open" : ""}`}
                >
                  <button
                    type="button"
                    className="faq-question"
                    aria-expanded={isOpen}
                    onClick={() => toggleFaq(idx)}
                  >
                    <span>{item.q}</span>
                    <span className="faq-question__icon">+</span>
                  </button>
                  <div className="faq-answer">
                    <p>{item.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="contact-section" id="contact" aria-labelledby="contact-heading">
        <div className="contact-inner">
          <h2 id="contact-heading" className="section-title section-title--light">
            דברו איתנו
          </h2>

          <div className="contact-rows">
            <a
              className="contact-row"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{PHONE_DISPLAY}</span>
              <span className="contact-row__icon"><WhatsappIcon /></span>
            </a>

            <a
              className="contact-row"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>mariage_family</span>
              <span className="contact-row__icon"><InstagramIcon /></span>
            </a>

            <a className="contact-row" href={`mailto:${EMAIL_ADDRESS}`}>
              <span>{EMAIL_ADDRESS}</span>
              <span className="contact-row__icon"><EmailIcon /></span>
            </a>
          </div>

          <p className="contact-tagline">מוזמנים לשמוע! 🥂</p>
        </div>
      </section>
    </div>
  );
};

export default Home;
